import { Document, Page, View, Text, Font, StyleSheet, usePDF, Image } from "@react-pdf/renderer";
import HeaderPDF from "../components/pdfs/HeaderPDF";
import Kanit1 from "../assets/fonts/Kanit/Kanit-Regular.ttf";
import Kanit2 from "../assets/fonts/Kanit/Kanit-Medium.ttf";
import Kanit3 from "../assets/fonts/Kanit/Kanit-SemiBold.ttf";
import Kanit4 from "../assets/fonts/Kanit/Kanit-Bold.ttf";
import Kanit5 from "../assets/fonts/Kanit/Kanit-MediumItalic.ttf";
import FooterPDF from "../components/pdfs/FooterPDF";
import { useAppContext } from "../hooks/useAppContext";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { convertNameToValue, convertNameToCheckbox } from "../utils/utils";
import dayjs from "dayjs";
import DialogLoading from "../components/UI/dialogs/DialogLoading";
import DialogSuccess from "../components/UI/dialogs/DialogSuccess";
import DialogError from "../components/UI/dialogs/DialogError";

Font.register({
    family: "Kanit",
    fonts: [
        { src: Kanit1, fontWeight: 400 },
        { src: Kanit2, fontWeight: 500 },
        { src: Kanit5, fontWeight: 500, fontStyle: "italic" },
        { src: Kanit3, fontWeight: 600 },
        { src: Kanit4, fontWeight: 700 },
    ],
});

const styles = StyleSheet.create({
    body: {
        flexGrow: 1,
        fontFamily: "Kanit",
    },
    viewer: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
    main__badge: {
        width: 220,
        padding: "2.5",
        fontSize: 11,
        textAlign: "center",
        color: "white",
        backgroundColor: "#00414f",
    },
    main__badge2: {
        width: 100,
        padding: "2.5",
        fontSize: 11,
        textAlign: "center",
        color: "white",
        backgroundColor: "#00414f",
    },
    main__badge3: {
        width: 110,
        padding: "2.5",
        fontSize: 11,
        textAlign: "center",
        color: "white",
        backgroundColor: "#00414f",
    },
    main__badge4: {
        width: 150,
        padding: "2.5",
        fontSize: 11,
        textAlign: "center",
        color: "white",
        backgroundColor: "#00414f",
    },
    header__topic1: {
        fontSize: 10,
        fontWeight: 600,
        color: "#00414f",
        padding: "0 8",
        marginBottom: 5,
    },
    header__topic2: {
        fontSize: 10,
        fontWeight: 600,
        color: "#4D4E4D",
        padding: "0 5",
    },
    box_dotted: {
        minHeight: 15,
        fontSize: 10,
        margin: "5px 5px 0",
        borderBottom: "1px dotted #333",
    },
});

const MyDocument = ({ pdfData }) => {
    return (
        <Document>
            <Page size="A4">
                <View style={styles.body}>
                    <HeaderPDF
                        pdfTitle="Final Drive Oil"
                        page={1}
                        totalPage={2}
                        data={pdfData}
                        convertNameToValue={convertNameToValue}
                    />

                    {pdfData && (
                        <View>
                            <View style={{ padding: "10px 20px" }}>
                                <View style={styles.main__badge4}>
                                    <Text style={{ fontWeight: "600" }}>Engine / Machine Picture</Text>
                                </View>
                                <View
                                    style={{
                                        flexDirection: "row",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        gap: "8px",
                                        margin: "5 0 15",
                                    }}
                                >
                                    <View style={{ width: "31%" }}>
                                        <View
                                            style={{
                                                width: "100%",
                                                height: "100px",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: "1px solid #333",
                                            }}
                                        >
                                            {convertNameToValue(pdfData, "img_machine1") && (
                                                <Image
                                                    src={convertNameToValue(pdfData, "img_machine1")}
                                                    style={{ objectFit: "contain" }}
                                                />
                                            )}
                                        </View>
                                    </View>
                                    <View style={{ width: "31%" }}>
                                        <View
                                            style={{
                                                width: "100%",
                                                height: "100px",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: "1px solid #333",
                                            }}
                                        >
                                            {convertNameToValue(pdfData, "img_machine2") && (
                                                <Image
                                                    src={convertNameToValue(pdfData, "img_machine2")}
                                                    style={{ objectFit: "contain" }}
                                                />
                                            )}
                                        </View>
                                    </View>
                                    <View style={{ width: "31%" }}>
                                        <View
                                            style={{
                                                width: "100%",
                                                height: "100px",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                border: "1px solid #333",
                                            }}
                                        >
                                            {convertNameToValue(pdfData, "img_machine3") && (
                                                <Image
                                                    src={convertNameToValue(pdfData, "img_machine3")}
                                                    style={{ objectFit: "contain" }}
                                                />
                                            )}
                                        </View>
                                    </View>
                                </View>
                                <View style={styles.main__badge}>
                                    <Text style={{ fontWeight: "600" }}>Visual External Machinery Inspection</Text>
                                </View>
                                <View style={{ marginBottom: 15 }}>
                                    <Text style={styles.header__topic1}>Temperature</Text>
                                    <View
                                        style={{
                                            flexDirection: "row",
                                            justifyContent: "center",
                                            gap: 8,
                                            padding: "0 5",
                                        }}
                                    >
                                        <View style={{ width: "32%", height: 120 }}>
                                            <View
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    border: "1px solid #333",
                                                }}
                                            >
                                                {convertNameToValue(pdfData, "img_point1_temperature") && (
                                                    <Image
                                                        src={convertNameToValue(pdfData, "img_point1_temperature")}
                                                        style={{ objectFit: "contain" }}
                                                    />
                                                )}
                                            </View>
                                            <Text style={{ fontSize: 9 }}>จุดวัดอุณหภูมิ (1)</Text>
                                            <View style={{ flexDirection: "row", gap: 10 }}>
                                                <Text style={{ fontSize: 9 }}>
                                                    อุณหภูมิที่วัดได้{" "}
                                                    {convertNameToValue(pdfData, "point1_temperature")}{" "}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={{ width: "32%", height: 120 }}>
                                            <View
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    border: "1px solid #333",
                                                }}
                                            >
                                                {convertNameToValue(pdfData, "img_point2_temperature") && (
                                                    <Image
                                                        src={convertNameToValue(pdfData, "img_point2_temperature")}
                                                        style={{ objectFit: "contain" }}
                                                    />
                                                )}
                                            </View>
                                            <Text style={{ fontSize: 9 }}>จุดวัดอุณหภูมิ (2)</Text>
                                            <View style={{ flexDirection: "row", gap: 10 }}>
                                                <Text style={{ fontSize: 9 }}>
                                                    อุณหภูมิที่วัดได้{" "}
                                                    {convertNameToValue(pdfData, "point2_temperature")}{" "}
                                                </Text>
                                            </View>
                                        </View>
                                        <View style={{ width: "32%", height: 120 }}>
                                            <View
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    border: "1px solid #333",
                                                }}
                                            >
                                                {convertNameToValue(pdfData, "img_point3_temperature") && (
                                                    <Image
                                                        src={convertNameToValue(pdfData, "img_point3_temperature")}
                                                        style={{ objectFit: "contain" }}
                                                    />
                                                )}
                                            </View>
                                            <Text style={{ fontSize: 9 }}>จุดวัดอุณหภูมิ (3)</Text>
                                            <View style={{ flexDirection: "row", gap: 10 }}>
                                                <Text style={{ fontSize: 9 }}>
                                                    อุณหภูมิที่วัดได้{" "}
                                                    {convertNameToValue(pdfData, "point3_temperature")}{" "}
                                                </Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                                <View>
                                    <View style={styles.main__badge3}>
                                        <Text style={{ fontWeight: "600" }}>Lubricants Test</Text>
                                    </View>

                                    <View>
                                        <Text style={styles.header__topic1}>
                                            Appearance
                                        </Text>
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                gap: 10,
                                                marginBottom: 5,
                                                padding: "0 5",
                                            }}
                                        >
                                            <View style={{ width: "32%", height: 100 }}>
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        border: "1px solid #333",
                                                    }}
                                                >
                                                    {convertNameToValue(pdfData, "img_used_oil_sample") && (
                                                        <Image
                                                            src={convertNameToValue(pdfData, "img_used_oil_sample")}
                                                            style={{ objectFit: "contain" }}
                                                        />
                                                    )}
                                                </View>
                                                <Text style={{ fontSize: 9, textAlign: "center" }}>
                                                    Used Oil Sample
                                                </Text>
                                            </View>
                                            <View style={{ width: "32%", height: 100 }}>
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        border: "1px solid #333",
                                                    }}
                                                >
                                                    {convertNameToValue(pdfData, "img_used_oil_sample_vs_new_oil") && (
                                                        <Image
                                                            src={convertNameToValue(
                                                                pdfData,
                                                                "img_used_oil_sample_vs_new_oil"
                                                            )}
                                                            style={{ objectFit: "contain" }}
                                                        />
                                                    )}
                                                </View>
                                                <Text style={{ fontSize: 9, textAlign: "center" }}>
                                                    Used Oil Sample VS New Oil
                                                </Text>
                                            </View>
                                            <View style={{ width: "32%", height: 100 }}>
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        border: "1px solid #333",
                                                    }}
                                                >
                                                    {convertNameToValue(pdfData, "img_bottom_of_Used_oil_sample") && (
                                                        <Image
                                                            src={convertNameToValue(
                                                                pdfData,
                                                                "img_bottom_of_Used_oil_sample"
                                                            )}
                                                            style={{ objectFit: "contain" }}
                                                        />
                                                    )}
                                                </View>
                                                <Text style={{ fontSize: 9, textAlign: "center" }}>
                                                    Bottom of Used Oil Sample
                                                </Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    )}

                    <FooterPDF />
                </View>
            </Page>

            <Page size="A4">
                <View style={styles.body}>
                    <HeaderPDF
                        pdfTitle="Final Drive Oil"
                        page={2}
                        totalPage={2}
                        data={pdfData}
                        convertNameToValue={convertNameToValue}
                    />

                    {pdfData && (
                        <View>
                            <View style={{ padding: "10px 20px" }}>
                                <View style={{ padding: "0 10", marginBottom: 10, flexDirection: "row", flexWrap: "wrap", gap: 5 }}>
                                    <View style={{ width: "48%" }}>
                                        <Text style={{ fontSize: 9, fontWeight: 500 }}>Color</Text>
                                        {convertNameToCheckbox(pdfData, "color")}
                                    </View>
                                    <View style={{ width: "48%" }}>
                                        <Text style={{ fontSize: 9, fontWeight: 500 }}>Clarity</Text>
                                        {convertNameToCheckbox(pdfData, "clarity")}
                                    </View>
                                    <View style={{ width: "48%" }}>
                                        <Text style={{ fontSize: 9, fontWeight: 500 }}>Free Water</Text>
                                        {convertNameToCheckbox(pdfData, "free_water")}
                                    </View>
                                    <View style={{ width: "48%" }}>
                                        <Text style={{ fontSize: 9, fontWeight: 500 }}>Particle / Sedment</Text>
                                        {convertNameToCheckbox(pdfData, "particle")}
                                    </View>
                                </View>
                                <View>
                                    <View style={styles.main__badge3}>
                                        <Text style={{ fontWeight: "600" }}>Lubricants Test</Text>
                                    </View>
                                    <View style={{ width: "50%" }}>
                                        <Text style={{ ...styles.header__topic1, marginBottom: 0 }}>
                                            Water Contamination
                                        </Text>
                                        <View style={{ padding: "0 10" }}>
                                            {convertNameToCheckbox(pdfData, "water_contamination")}
                                        </View>
                                    </View>
                                </View>

                                <View>
                                    <Text style={{ ...styles.header__topic1, marginBottom: 5 }}>
                                        Viscosity by Viscosity Stick
                                    </Text>
                                    <View style={{ flexDirection: "row", gap: "20", marginTop: 2.5, padding: "0 10" }}>
                                        <View style={{ width: "40%" }}>
                                            <View
                                                style={{
                                                    width: "100%",
                                                    height: "100px",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    border: "1px solid #333",
                                                }}
                                            >
                                                {convertNameToValue(pdfData, "img_viscosity_comparison") && (
                                                    <Image
                                                        src={convertNameToValue(pdfData, "img_viscosity_comparison")}
                                                        style={{ objectFit: "contain" }}
                                                    />
                                                )}
                                            </View>
                                        </View>
                                        <View style={{ width: "60%" }}>
                                            {convertNameToCheckbox(pdfData, "viscosity_by_viscosity_stick")}
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    )}

                    <FooterPDF />
                </View>
            </Page>
        </Document>
    );
};

const FinalDriveOilPDF = () => {
    const { formName } = useParams();
    const { isSubmit, setIsSubmit, pdfDatas } = useAppContext();
    const [dialogInfo, setDialogInfo] = useState(false);
    const [dialogSuccess, setDialogSuccess] = useState(false);
    const [dialogError, setDialogError] = useState(false);
    const [instance, update] = usePDF({ document: <MyDocument pdfData={pdfDatas} /> });

    const blobToBase64 = (blob) => {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            if (blob) {
                reader.readAsDataURL(blob);
            }
        });
    };

    const onSuccess = () => {
        setDialogSuccess(false);
        setIsSubmit(false);
        window.location.reload();
    };

    const onFailed = () => {
        setDialogError(false);
        setIsSubmit(false);
    };

    useEffect(() => {
        update();
        // eslint-disable-next-line
    }, [pdfDatas]);

    useEffect(() => {
        if (!instance.loading) {
            blobToBase64(instance.blob)
                .then((res) => {
                    if (pdfDatas?.length > 0 && res && isSubmit && instance?.blob?.size > 366721) {
                        setDialogInfo(true);
                        axios
                            .post(
                                `https://report.cxcbs.com/api/v1/submit/${formName}`,
                                {
                                    subject: `Report: ${
                                        pdfDatas.find((item) => item.name === "company_name").value
                                    } ${formName} ${dayjs().format("DD-MM-YYYY")}`,
                                    email_receiver: pdfDatas.find((item) => item.name === "email").value,
                                    attach_file: [
                                        {
                                            type: "contentBase64",
                                            filename: `${formName}.pdf`,
                                            data: res.split("data:application/pdf;base64,")[1],
                                        },
                                    ],
                                },
                                {
                                    headers: {
                                        Authorization: "abcdefghijklnmopqrswutxyz",
                                    },
                                    timeout: 60000,
                                }
                            )
                            .then((res) => {
                                if (res.data.Code === "20000") {
                                    setDialogSuccess(true);
                                } else {
                                    setDialogError(true);
                                }
                                setDialogInfo(false);
                            })
                            .catch((e) => {
                                console.log(e);
                                setDialogError(true);
                                setIsSubmit(false);
                                setDialogInfo(false);
                                setDialogSuccess(false);
                            });
                    }
                })
                .catch((e) => {
                    console.log(e);
                    setIsSubmit(false);
                });
        }

        // eslint-disable-next-line
    }, [instance, isSubmit, formName]);

    return (
        <>
            <DialogLoading open={dialogInfo} />
            <DialogSuccess open={dialogSuccess} onClose={onSuccess} />
            <DialogError open={dialogError} onClose={onFailed} />
        </>
    );
};

export default FinalDriveOilPDF;
